import { LoggerSender, LogType } from "@amzn/hvh_client_side_error_tracker/dist/logger-sender";
import { plainFetcher } from "../helpers/fetcher";

const createOnFlush = (url: string) => async (metrics: any) => {
  try {
    await plainFetcher(url, {
      method: "POST",
      body: JSON.stringify({
        metrics,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });
    return true;
  } catch (e) {
    return false;
  }
};

export class MetricsSender {
  loggerSender: LoggerSender;

  constructor(url: string) {
    this.loggerSender = new LoggerSender({
      onFlush: createOnFlush(url),
      urlResolver: () => Promise.resolve(url),
    });
  }

  push(metric: any) {
    if (process.env.NODE_ENV === "development") {
      console.log(metric);
    }
    this.loggerSender.push(JSON.stringify(metric), LogType.Metric);
  }
}
